import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import Background from '@/components/Background.vue';
import VariableLogo from '@/components/VariableLogo.vue';
import Thumbnail from '@/components/Thumbnail.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import { localizedDeliveryEstimate } from '@/utils/LocalizationsUtils';
import { formatPrice } from '@/mixins/MenuLocalization';
import { PaymentStatus } from '@/models/PaymentDetails';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
let Command = class Command extends Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.phone = '';
        this.date = '';
        this.hour = '';
        this.address = '';
        this.totaltext = '';
        this.visa = false;
        this.deliveryCost = 0;
        this.nameRestaurant = '';
        this.dateNow = new Date();
        this.showButtons = false;
        this.order = this.$store.state.order;
        this.menu = this.$store.state.menu;
        this.thumbnailBorder = `border: 1px ${this.$store.getters.colors.backgroundColor} solid;`;
        this.goodEnding = false;
        this.loading = false;
        this.delivery = this.$store.state.deliveryMenu;
        this.deliveryEstimate = '';
        this.orderAddressStore = this.$store.state.order.address;
        this.user = this.$store.state.user;
    }
    get readableId() {
        if (this.order?.number) {
            return '#' + this.order.number;
        }
        return '';
    }
    parsePaymentStatus(status) {
        const paymentStatus = status.toUpperCase();
        if (PaymentStatus[paymentStatus])
            return PaymentStatus[paymentStatus];
        return PaymentStatus.UNKNOWN;
    }
    reduceIngredients(ingredients, start) {
        return ingredients.reduce((p, i, index, array) => p +
            i.localizedNames +
            ': ' +
            i.extraIngredients.map(rest => {
                if (rest.selected == true)
                    return ' ' + rest.localizedNames;
            }) +
            `${index + 1 == array.length ? '' : ', ' + start + ' '}`, start + ' ');
    }
    changeAddress() {
        this.$router.push('/maps');
    }
    created() {
        this.getInfoRest();
        this.getInfoOrder();
        this.getTotal();
        this.getEstimate();
    }
    getInfoRest() {
        const menu = this.$store.state.menu;
        if (menu) {
            this.nameRestaurant = menu.name;
        }
    }
    getEstimate() {
        if (this.delivery.descriptionEstimates) {
            this.deliveryEstimate = localizedDeliveryEstimate(this.delivery);
        }
    }
    getInfoOrder() {
        const phoneExt = this.$store.state.order.phoneExt;
        phoneExt
            ? (this.phone = this.$store.state.order.phone + ' / Ext: ' + phoneExt)
            : (this.phone = this.$store.state.order.phone);
        this.date = this.dateNow.getDate() + '-' + (this.dateNow.getMonth() + 1) + '-' + this.dateNow.getFullYear();
        this.hour = ('0' + this.dateNow.getHours()).slice(-2) + ':' + ('0' + this.dateNow.getMinutes()).slice(-2);
        this.address = this.getAddress();
    }
    getAddress() {
        if (!this.orderAddressStore) {
            this.orderAddressStore = this.$store.state.address;
        }
        let addr = '';
        this.orderAddressStore.street ? (addr += this.orderAddressStore.street + ', ') : '';
        this.orderAddressStore.extNumber ? (addr += this.orderAddressStore.extNumber + ', ') : '';
        this.orderAddressStore.number ? (addr += this.orderAddressStore.number + ', ') : '';
        this.orderAddressStore.region ? (addr += this.orderAddressStore.region + ', ') : '';
        this.orderAddressStore.references ? (addr += this.orderAddressStore.references + ', ') : '';
        this.orderAddressStore.postal ? (addr += this.orderAddressStore.postal) : '';
        return addr;
    }
    getTotal() {
        if (this.order) {
            if (this.$store.state.currency == 'MXN') {
                const total = this.order.subtotal + this.order.deliveryCost;
                this.totaltext = `${formatPrice(total)} MXN`;
            }
            else {
                let total = this.order.subtotal;
                const delivery = this.order.deliveryCost;
                const localizations = this.$store.state.menu.localizations;
                localizations.forEach((docLocalization) => {
                    if (docLocalization.currency == this.$store.state.currency) {
                        total = total * parseInt(docLocalization.change) + delivery;
                        this.totaltext = `${formatPrice(total)} MXN`;
                    }
                });
            }
        }
        else {
            this.totaltext = '';
        }
    }
    async resetOrder() {
        await this.$store.dispatch('setNewOrder');
        this.$router.push('/menu');
    }
};
__decorate([
    Prop({ default: '' })
], Command.prototype, "orderId", void 0);
__decorate([
    Prop({ default: '' })
], Command.prototype, "checkoutId", void 0);
__decorate([
    Prop({ default: '' })
], Command.prototype, "paymentStatus", void 0);
Command = __decorate([
    Component({
        components: {
            CommonHeader,
            VariableLogo,
            Background,
            Thumbnail,
            BlankLayout,
            SpinnerHolder
        }
    })
], Command);
export default Command;
